"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
const numeral_1 = __importDefault(require("numeral"));
const formatNumber = (number) => {
    const formattedNumber = number.toString().length > 3
        ? (0, numeral_1.default)(number)
            .format("0.0a")
            .replace(" ", "")
        : (0, numeral_1.default)(number).format("0 a");
    return formattedNumber.toUpperCase();
};
exports.formatNumber = formatNumber;
//# sourceMappingURL=format-numbers.js.map